import 'vue-select/dist/vue-select.css';
import '@/services/errors';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

const app = createApp(App);

// Vue has app.config.warnHandler, but it isn't actually called in all cases, so let's just patch console.warn directly to put these in our face:
if (DEPLOYMENT_ENVIRONMENT === 'test') {
  let lastAlert = 0;
  const warnOrig = console.warn;
  function warningArgToString(arg: unknown): string {
    if (typeof arg === 'string') {
      return arg;
    }

    if (arg instanceof Error) {
      return arg.stack || arg.message;
    }

    try {
      return JSON.stringify(arg);
    } catch {
      return Object.prototype.toString.call(arg);
    }
  }

  console.warn = (...args) => {
    if (args[0] && /Vue/i.test(args[0]) && Date.now() > lastAlert + 1000) {
      alert(args.map(warningArgToString).join(' '));
      lastAlert = Date.now();
    }
    warnOrig(...args);
  };
}

app.use(router);

app.mount('#app');
